<template>
  <v-app-bar class="pa-n3" color="accent" elevate-on-scroll scroll-target="#scrolling-techniques-7">
    <v-container>
      <v-row style="font-family: 'Avenir';" align="center" justify="center">
        <v-btn class="mr-7" @click="upgrade">{{ $t('message_TopProCTA') }} »</v-btn>
        {{ proAdvantage }}
        <v-icon class="ml-3">fa-regular fa-bolt</v-icon>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
import Advantages from '../assets/proAdvantages';

export default {
  name: 'TopProCTA',
  data() {
    return {
      proAdvantage: '',
      overlaySeeAdvantages: true,
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.refreshProAdvantage();
    },
    '$i18n.locale': function () {
      this.refreshProAdvantage();
    },
  },
  mounted() {
    this.refreshProAdvantage();
  },
  methods: {
    refreshProAdvantage() {
      const locale = this.$i18n.locale;
      // Use advantages in current language if available, otherwise fall back to English
      const availableAdvantages = Advantages[locale] || Advantages.en;
      const randomIndex = Math.floor(Math.random() * availableAdvantages.length);
      this.proAdvantage = availableAdvantages[randomIndex];
    },
    upgrade() {
      this.$router.push("/subscription-plans");
    }
  }
}
</script>



<style scoped>
.convert-now-btn {
  font-size: 10px !important;
  background-color: #111111 !important;
  color: #FFFFFF !important;
  border: 1px solid #111111 !important;
}
</style>
